module.exports = __webpack_public_path__ + "img/hr-green-asterisk-08.d39a409c.png";